@let isHighGuide = viewModel.isHighGuide$ | async;

<div class="app-body mt-0 mb-0" [class.blurred-background]="viewModel.blurTheScreen$ | async">
  <app-sidebar-navigation
    *rxIf="viewModel.sidebarVisible$ | push: 'immediate'"
    (collapsed)="viewModel.connectToSideNavCollapsed($event)" />
  <main class="main">
    <app-page-banner></app-page-banner>
    <main
      class="main-content"
      [style.padding]="isHighGuide ? '0' : null"
      [style.overflow]="isHighGuide ? 'unset' : null">
      <router-outlet></router-outlet>
      <app-toast-events [margin]="viewModel.toastMargin$ | push"></app-toast-events>
    </main>
  </main>
</div>
